import Section from './Section.jsx';

export default function BoatRamps({ note, defaultOpen }) {
  if (!note) return null;
  return (
    <Section title="Boat ramps" eyebrow="Launch windows" collapsible defaultOpen={defaultOpen}>
      <p className="leading-relaxed">{note}</p>
    </Section>
  );
}
